import { Component, OnInit, ViewChild, APP_ID, HostBinding, ContentChild, DOCUMENT } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { Inject, TemplateRef } from '@angular/core';
import { CategoriesService } from 'src/app/service/categories.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddCategoryDialogComponent } from 'src/app/core/dialogs/add-category-dialog/add-category-dialog.component';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { BoardsService } from 'src/app/service/boards.service';
import { GridOptions } from 'ag-grid-community';
export interface DialogData {
  performAction: string;
  placeholder: string;
  page;
}
export interface deleteData {
  id: Number;
  category_name: string;
  page;
}
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  standalone: false,  // NOSONAR
})
export class CategoriesComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any
  gridOptions: GridOptions;
  setPagination = 'true';
  defaultColDef;
  paginationPageSize: number = 30;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  eIconGui;
  rowCount;
  addNewRowData;
  columnDefs;
  rowData;
  icons;
  frameworkComponents;
  context: any;
  selectedRows: any = [];
  successMessage = '';
  errorMessage = '';
  totalRecords = 0; // Replace with your actual total records count
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ]
  @ContentChild("templateVariable")
  public templateVariable: TemplateRef<any>;
  // @ViewChild('agGrid', { static: true }) agGrid: GridOptions
  @ViewChild('agGrid', { static: true }) agGrid
  dynamicHeight: number;
  constructor(public addDialog: MatDialog,
    private readonly categoriesService: CategoriesService,
    public dialog: MatDialog, @Inject(DOCUMENT) _document, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly boardService: BoardsService) {
    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.context = {
      componentParent: this
    };
    this.gridOptions = { suppressRowClickSelection: true }
    this.columnDefs = [
      {
        headerName: "ID", headerClass: "table_id", field: "categoryID", cellClass: "cell_idno", width: 120,
        sortable: true, unSortIcon: true, autoHeight: true
      },
      {
        headerName: "DESCRIPTION", headerClass: "description", field: "description",
        cellClass: "cell_description", width: 1025,
        sortable: true, unSortIcon: true, autoHeight: true
      },
      {
        headerName: "ACTIONS", field: "category_action",
        width: 120, headerClass: "editdelete",
        cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
          }
        }
      }];
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    };
    this.defaultColDef = {
      wrapText: true
    };
    this.icons = {
      sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
    };
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }
  loadData() {
    this.ngxUiLoaderService.start("loader-01");
    //API Integration
    this.rowData = [];
    this.categoriesService.getDetails().subscribe(result => {
      console.info("calling getdetails")
      console.info("result", result);
      if (result?.length > 0) {
        this.rowData = result;
        this.rowCount = this.rowData.length;
        if (this.rowData.length) {
          this.totalRecords = this.rowData.length;
          this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
          this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
          this.sRecord = 1
          this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
          if (this.cPage > this.tPage) {
            this.cPage = 1;
          }
        }
        //storing categories data in local
        localStorage.setItem('categories-data', JSON.stringify(result));
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  }
  goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
  goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
  onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
  getCurrentPage(): boolean {
    this.currentPageNo = this.agGrid.api?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    this.updatePaginationDetails();
  }
  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();
      this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
      this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  openDialog(): void {
    console.info("open dialog");
    const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
      disableClose: true,
      width: '401px',
      data: { performAction: 'AddCell', placeholder: '' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'AddCell') { // NOSONAR
        //API Integration
        const dataArr = {
          "categoryID": null,
          "description": result.data
        }
        this.ngxUiLoaderService.start("loader-01");
        this.categoriesService.addCategory(dataArr).subscribe(result => {
          console.info("result", result);
          if (!result) {
            this.loadData();
            this.errorMessage = 'Category already exists!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
          else if (result) {
            this.loadData();
            this.successMessage = 'Category added successfully!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
        });
      }
    });
  }
  deleteRow(val) {
    let categoryName;
    let id;
    this.rowData.filter(x => x.categoryID == val).forEach(e => { // NOSONAR
      this.selectedRows.push(e);
      id = e.categoryID;
      categoryName = e.description;
    });
    const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
      disableClose: true,
      width: '510px',
      data: { id: id, category_name: categoryName, page: 'category' }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.info("data to be deleted:", result.data);
      const deletejson = {
        "categoryID": result.data,
        "description": categoryName
      }
      this.deleteRecords(deletejson);
      console.info("json", deletejson);
    });
  }
  deleteRecords(dataArr) {
    console.info("the delete array in deleterecords", dataArr);
    this.ngxUiLoaderService.start("loader-01");
    this.categoriesService.deleteCategory(dataArr).subscribe(_result => {
      this.successMessage = 'Deleted Row(s) Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
      //fetch latest row data after deleting
      this.loadData();
    });
  }
  editRow(val) {
    let desc;
    let catID;
    this.rowData.filter(x => x.categoryID == val).forEach(e => { // NOSONAR
      desc = e.description;
      catID = e.categoryID;
    });
    const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
      disableClose: true,
      width: '401px',
      data: { performAction: 'EditCell', placeholder: desc, page: 'Category' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'EditCell') { // NOSONAR
        //API Integration
        const dataArr = {
          "categoryID": catID,
          "description": result.data
        }
        this.ngxUiLoaderService.start("loader-01");
        this.categoriesService.editCategory(dataArr).subscribe(_result => {
          this.successMessage = 'Category updated successfully!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          //fetch latest row data after editing
          this.loadData();
          // }
        });
      }
    });
  }
  ngOnInit(): void {
    this.ngxUiLoaderService.start("loader-01");
    // clear contingency data
    sessionStorage.removeItem('contData');
    this.boardService.deleteContingenyList().subscribe(_result => {
      // contingency list deleted
    });
    // not needed - hitting api directly
    // let catTemp = JSON.parse(localStorage.getItem('categories-data'));
    this.loadData();
  }
  refreshData() {
    this.loadData();
  }
}